const namespace = '[User Generated Content]';

export const USER_GENERATED_CONTENT_GET = `${namespace} USER GENERATED CONTENT GET`;
